import { observable, action, decorate } from 'mobx'

class formGeneralData {
  form = {}

  setForm = (theForm) => {
    this.form = theForm
  }
  resetForm = () => {
    this.form = {}
  }
}
decorate(formGeneralData, {
  form: observable,
  setForm: action,
  resetForm: action,
})
const FormGeneralData = new formGeneralData()

export default FormGeneralData
